import { createColumnHelper } from '@tanstack/react-table';
import { lt } from '@mews/framework';
import { ColumnFilterType, Link } from '@optimus-web/core';
import { PortfolioCentralProductOverviewEntry } from '@mews-commander/data-access';
import { UnicodeEntity } from '@mews/enums';
import { useCentralProductSidePanelContext } from '../../CentralProductSidePanel/CentralProductSidePanelContext';
import { RowActionCell } from './RowActionCell';
import { ProductSidePanelTabValues } from './types';
import { PortfolioCentralProductOverviewEntryColumns } from './CentralProductTable';

type ViewDetail = Pick<PortfolioCentralProductOverviewEntry, 'id' | 'name' | 'propertyIds'> & {
    tab: ProductSidePanelTabValues;
};

const columnHelper = createColumnHelper<PortfolioCentralProductOverviewEntryColumns>();

const NameCell = ({ id, name, tab, propertyIds }: ViewDetail) => {
    const { open } = useCentralProductSidePanelContext();
    return (
        <Link standalone variant="basic" onClick={() => open(id, tab, propertyIds)} data-disable-click-away>
            {name}
        </Link>
    );
};

export const centralProductTableColumns = [
    columnHelper.accessor('name', {
        header: () => lt('InternalName'),
        enableSorting: true,
        enableColumnFilter: true,
        meta: {
            filtersType: ColumnFilterType.String,
        },
        cell: (props) => <NameCell {...props.row.original} tab={ProductSidePanelTabValues.Details} />,
    }),
    columnHelper.accessor('properties', {
        header: () => lt('Property'),
        cell: (props) => {
            const propsValue = props.getValue();

            return propsValue.length > 0 ? propsValue.length : UnicodeEntity.Dash;
        },
    }),
    columnHelper.accessor('key', {
        header: () => lt('ProductKey'),
        enableSorting: true,
        enableColumnFilter: true,
        meta: {
            filtersType: ColumnFilterType.String,
        },
    }),
    columnHelper.display({
        id: 'actions',
        meta: { align: 'end' },
        cell: ({
            row: {
                original: { id, propertyIds },
            },
        }) => <RowActionCell id={id} propertyIds={propertyIds} />,
    }),
];
